import styled from '@emotion/styled';
import { useSettingModal} from '../../../../hooks/Context';
import { SettingContextI } from '../../../../types';
import {FaTimes as CancelIcon} from 'react-icons/fa';
import {useEffect} from 'react';




export const ModalContainer = styled.div`
    position: fixed;
    width:100%;
    height:100%;
    display:flex;
    justify-content:center;
    background-color: #4E534F80;
    z-index: 10;
    top:0;
    left: 0;
    overflow-x:hidden;
    overflow-y:scroll;
`;

const BackDrop = styled('div')`
    position: fixed;
    width: 100%;
    height:100%;
    z-index: -1;
`


export const StyleCancel = styled.span`
    position:absolute;
    top:0px;
    right:-50px;
    width:40px;
    height:40px;
    color:#fff;
    background-color: rgba(255,255,255,0.3);
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    font-size: 20px;
    cursor: pointer;
`;

export const ModalContent = styled.div`
    width:fit-content;
    position: relative;
    top:50px;
    background-color: #fff;
    height:fit-content !important;
`;


export default  function SettingsModal(props:any){
    const {modalContent:modal,showModal:show,setShowModal,setModalContent,setShowCancel,showCancel}:SettingContextI = useSettingModal();
    useEffect(()=>{
        return () =>{setModalContent(<div></div>);setShowCancel(true)}
    },[])
    return(
        <>
        {show ?
            <>
            <ModalContainer >
                <ModalContent>
                    {showCancel ?
                        <StyleCancel onClick={()=>setShowModal(false)}>
                            <CancelIcon />
                        </StyleCancel>
                    :''}
                    {modal}
                </ModalContent>
                <BackDrop className='drop' onClick={()=>setShowModal(false)}/> 
            </ModalContainer>  
            </>
            
        :''}
        
        </>

     
    )
}

export {default as CreateRoutePayment} from './CreateRoutePayment';
export  {default as CreateAdminUser} from './CreateAdminUser';
export {default as ViewDetails} from './ViewDetails';
export {default as AddClaim} from './AddClaim';
export {default as AssignRole} from './AssignRole';
export {default as DisableAdmin} from './DisableAdmin';
export {default as Waiting} from './Waiting';
export {default as CreateClaim}  from './CreateClaim';
export {default as ViewClaim} from './ViewClaim';
export {default as DisableClaim} from './DisableClaim';
export {default as CreateAdminConfig} from './CreateAdminConfig';
export {default as ViewConfig} from './ViewConfig';
export {default as DisableZones} from './DisableZones';
export {default as ViewZones} from './ViewZones';
export {default as CreateZones}  from './CreateZones';
export {default as ViewSpecialisation}  from './ViewSpecialisation';
export {default as DisableSpecialisation}  from './DisableSpecialisation';
export {default as CreateSpecialisation}  from './CreateSpecialisation';
export {default as DeleteAdminConfig} from './DeleteAdminConfig';